<template>
    <div>
        <div v-for="(items) in games" :key="items.id" class="row justify-content-center">
            <div v-for="(item) in items" :key="item.id" class="col-lg-4 col-md-5 m-md-3 mb-2 card cm-card">
                <img class="card-img-top pt-3" :src="item.gameImage" alt="Card image cap">
                <div class="card-body">    
                    <h1 class="card-title cm-gameintro-name">
                        {{item.gameName}}
                    </h1>
                    <h4 class="card-title cm-gameintro-title">
                        {{item.gameTitle}}
                    </h4>
                    <p class="card-text cm-gameintro-intro">
                        {{item.gameIntro}}
                    </p>
                    <p class="card-text cm-gameintro-intro" v-for="(customize) in item.customizeList" :key="customize.id">
                        <a :href="customize.content" target="_blank">{{customize.title}}</a>
                    </p>
                    <p class="cm-game-icon">
                        <a :href="item.googleplayUrl" v-show="item.googleplayUrl!=''" class="cm-game-android" style="background-size: 90%;" target="_blank" alt="googleplay"></a>
                        <a :href="item.appstoreUrl" v-show="item.appstoreUrl!=''" class="cm-game-ios" style="background-size: 90%;" target="_blank" alt="applestore"></a>
                        <a :href="item.apkUrl" v-show="item.apkUrl!=''" class="cm-game-apk" style="background-size: 90%;" target="_blank" alt="apkdownload"></a>
                        <a :href="item.fbUrl" v-show="item.fbUrl!=''" class="cm-game-facebook" style="background-size: 90%;" target="_blank" alt="facebook"></a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserAgentUtil from "@/assets/js/util/UserAgentUtil.js";
export default {
    data() {
        return {
            games: [],
            GamesInfo:{},
            userAgentInfo: UserAgentUtil.parseUserAgent(navigator.userAgent)
        };
    },
    watch: {
        content(val)
        {
            this.GamesInfo = val;
            this.getGamesInfo();
        }
    },
    methods: {
        getGamesInfo() {
            var Result = this.GamesInfo.data;
            var data = [];
            this.games=[];
            if(Result.result == "success")
            {
                var ContentData = Result.data;
                if(!this.ismore)
                {
                    for(let i=0; i<ContentData.moreIndex && i<ContentData.bulletin.length; i++)
                    {
                        data.push(this.setGamesInfo(i,ContentData));
                    }
                }
                else
                {
                    for(let i= ContentData.moreIndex; i<ContentData.bulletin.length; i++)
                    {
                        data.push(this.setGamesInfo(i,ContentData));
                    }
                }
                
                if(data.length>0)
                {
                    for(let i=0; i<data.length; i+=2)
                    {
                        if(i+1<data.length)
                        {
                            this.games.push([data[i],data[i+1]]);
                        }
                        else
                        {
                            this.games.push([data[i]]);
                        }
                    }
                }
            }
        },
        setGamesInfo(i,ContentData)
        {
            let jsonContent = {};
            let bulletin;
            jsonContent = {};
            bulletin = ContentData.bulletin[i];
            jsonContent.gameImage = bulletin.imgHost + bulletin.imgPath + bulletin.imgFileName;
            jsonContent.gameName = bulletin.content.GameName;
            jsonContent.gameTitle = bulletin.title;
            jsonContent.gameIntro = bulletin.content.GameContent;
            jsonContent.appstoreUrl = bulletin.content.GameAppStoreUrl;
            jsonContent.googleplayUrl = bulletin.content.GameAndroidUrl;
            jsonContent.apkUrl = bulletin.content.GameThirdUrl;
            jsonContent.fbUrl = bulletin.content.GameFbUrl;
            if(this.userAgentInfo.operatingSystemName == UserAgentUtil.OS.Android) {
                jsonContent.appstoreUrl = "";
            }
            else if(this.userAgentInfo.operatingSystemName == UserAgentUtil.OS.iOS) {
                jsonContent.googleplayUrl = "";
                jsonContent.apkUrl = "";
            }

            let customizeList = [];
            let customizeJson = {};
            for(let index=1; ; index++)
            {
                if(bulletin.content["GameCustomizeTitle"+index])
                {
                    customizeJson.title = bulletin.content["GameCustomizeTitle"+index];
                    customizeJson.content = bulletin.content["GameCustomizeContent"+index];
                    //若不使用此"深copy"方式，則會push記憶體位址而非值(淺copy)
                    customizeList.push(Object.assign({}, customizeJson));
                }
                else
                {
                    break;
                }
            }
            if(customizeList.length > 0)
            {
                jsonContent.customizeList = customizeList;
            }
            return jsonContent;
        }
    },
    props: ['ismore','content']
}
</script>